import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Open an external URL correctly on BOTH web and Capacitor native.
 *
 * A plain `<a target="_blank">` is not enough on native: the app runs inside a
 * WebView, so the link opens *in the WebView* rather than handing off to the
 * system — which, for store URLs, means the user never reaches the native App
 * Store / Play app (and can get stranded with no way back). `Browser.open()` is
 * the Capacitor path, and it's the pattern the store-review flow already uses
 * (`JourneyThrowbackPanel`).
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
